// dexie db
import Dexie from 'dexie'
const dbdexie = new Dexie('chemicaldata')
export default dbdexie

dbdexie.version(4).stores({
  chem: '++id,&name,date',
  request: 'url, time, response',
  locations: 'name, desc'
})
dbdexie.open().catch(function(e) {
  console.error('Open failed: ' + e)
})
